import type { one_to_one } from '@fireworkhq/proto-contract'
import type { Message } from '@oneToOne/shared/components/chat/types'

/** @returns A message transformed into a version consumable by the UI. */
export function transformMessage(
  message: one_to_one.shared.Message,
  reader: 'agent' | 'visitor',
) {
  const messageType = getMessageType(message, reader)
  let content =
    (message.text_message?.content || message.system_message?.content) ?? ''
  if (
    (messageType === 'info' || messageType === 'error') &&
    message.created_at
  ) {
    content = `${content} ${new Date(message.created_at).toLocaleTimeString(
      [],
      {
        hour: 'numeric',
        minute: '2-digit',
      },
    )}`
  }

  const transformedMessage: Message = {
    ...message,
    content,
    name: message.text_message?.name ?? message.media_message?.name ?? '',
    type: messageType,
  }
  const attachment = message.media_message?.attachments?.[0]
  if (attachment) {
    transformedMessage.attachment = attachment
  }

  return transformedMessage
}

function getMessageType(
  message: one_to_one.shared.Message,
  reader: 'agent' | 'visitor',
) {
  let messageType: Message['type']
  const author = message.text_message?.author || message.media_message?.author
  if (message.system_message?.type === 'SYSTEM_MESSAGE_TYPE_INFO') {
    messageType = 'info'
  } else if (message.system_message?.type === 'SYSTEM_MESSAGE_TYPE_ERROR') {
    messageType = 'error'
  } else if (author === 'AUTHOR_AGENT' && reader === 'agent') {
    messageType = 'outgoing_message'
  } else if (author === 'AUTHOR_AGENT' && reader === 'visitor') {
    messageType = 'incoming_message'
  } else if (author === 'AUTHOR_AUTOMATION' && reader === 'agent') {
    messageType = 'outgoing_message'
  } else if (author === 'AUTHOR_AUTOMATION' && reader === 'visitor') {
    messageType = 'incoming_message'
  } else if (author === 'AUTHOR_VISITOR' && reader === 'visitor') {
    messageType = 'outgoing_message'
  } else if (author === 'AUTHOR_VISITOR' && reader === 'agent') {
    messageType = 'incoming_message'
  } else {
    messageType = 'incoming_message'
  }

  return messageType
}
